import React from "react";
import { Link } from "react-router-dom";

export type NavItem = {
  key: string;
  label: string;
  to?: string;
  type?: "link" | "button";
  visible?: boolean;
  queryParam?: string;
  onClick?: () => void;
};

type NavLinksProps = {
  items: NavItem[];
  locationPathname: string;
  locationSearch: string;
  onNavigate?: () => void;
  containerRef?: React.RefObject<HTMLUListElement>;
  underlineStyle?: React.CSSProperties;
  underlineRef?: React.RefObject<HTMLDivElement>;
  className?: string;
  style?: React.CSSProperties;
};

const NavLinks: React.FC<NavLinksProps> = ({
  items,
  locationPathname,
  locationSearch,
  onNavigate,
  containerRef,
  underlineStyle,
  underlineRef,
  className,
  style,
}) => {
  const renderLink = (item: NavItem) => {
    if (item.type === "button" || !item.to) {
      return (
        <button
          type="button"
          onClick={() => {
            onNavigate?.();
            item.onClick?.();
          }}
          className="nav-link fw-bold"
          style={{
            background: "none",
            border: "none",
            color: "#ffffff",
            cursor: "pointer",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) =>
            ((e.currentTarget as HTMLElement).style.color = "#00c6ff")
          }
          onMouseLeave={(e) =>
            ((e.currentTarget as HTMLElement).style.color = "#ffffff")
          }
        >
          {item.label}
        </button>
      );
    }

    const isQueryMatch = item.queryParam
      ? locationSearch.includes(item.queryParam)
      : false;
    const isPathMatch = item.to ? locationPathname === item.to : false;
    const isActive = isQueryMatch || isPathMatch;

    return (
      <Link
        to={item.to}
        onClick={onNavigate}
        className={`nav-link fw-bold ${isActive ? "active-nav-link" : ""}`}
        style={{
          color: isActive ? "#00c6ff" : "#ffffff",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={(e) => {
          if (!isActive)
            (e.currentTarget as HTMLElement).style.color = "#00c6ff";
        }}
        onMouseLeave={(e) => {
          if (!isActive)
            (e.currentTarget as HTMLElement).style.color = "#ffffff";
        }}
      >
        {item.label}
      </Link>
    );
  };

  return (
    <ul ref={containerRef} className={className} style={style}>
      {items
        .filter((item) => item.visible !== false)
        .map((item) => (
          <li className="nav-item" key={item.key}>
            {renderLink(item)}
          </li>
        ))}
      {underlineStyle && <li role="presentation" aria-hidden="true" style={{ listStyle: "none" }}><div ref={underlineRef} style={underlineStyle} /></li>}
    </ul>
  );
};

export default NavLinks;
